import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD7Lif_vO8DoDXGuLUChpl1IBtqXzKXZ1c",
  authDomain: "meridian-cycle.firebaseapp.com",
  projectId: "meridian-cycle",
  storageBucket: "meridian-cycle.firebasestorage.app",
  messagingSenderId: "946980383472",
  appId: "1:946980383472:web:7c6b62b92e64f18abdb035",
  measurementId: "G-2FTPJWSLB4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

// analytics�� �ܺη� �������� �̻�� ���� ����
export { auth, db, analytics };